import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatsComponent } from './chats.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IonicModule } from '@ionic/angular';
import { ChatDatetimeModule } from 'src/app/pipe/chat-datetime/chat-datetime.module';
import { ListStatusModule } from 'src/app/share/list-status/list-status.module';
import { AvatarModule } from 'src/app/share/avatar/avatar.module';

@NgModule({
	declarations: [ChatsComponent],
	exports: [ChatsComponent],
	imports: [
		CommonModule,
		IonicModule,
		FlexLayoutModule,
		ChatDatetimeModule,
		ListStatusModule,
		AvatarModule,
		TranslateModule
	]
})
export class ChatsModule { }
